import React from 'react';
import immutable from 'immutable';
import { Config } from '../../../constants/constant';
import * as Session from '../../../domain/Session';
import * as Pager from '../../../domain/Pager';
import * as Category from '../../../domain/Category';
import * as Topic from '../../../domain/Topic';
import Tab from './Tab';
import List from './List';

/**
 * トピック一覧ルートコンポーネント
 */
interface Props {
  session: Session.Value;
  title: string;
  topics: immutable.List<Topic.Entity>;
  categories: Category.EntityList;
  pager: Pager.Value;
}

const TopicListComponent: React.FC<Props> = props => {
  const { title, topics, categories, pager } = props;
  const pageTitle = `「 ${title} 」のトピック一覧`;
  const sort = pager.filter.get('sort');
  const categoryCode = pager.filter.get('categoryCode');
  const basePathname = '/topic/list';
  const baseAsPath = categoryCode === 0 ? '/topic/list' : `/topic/list/${categoryCode}`;
  const baseQuery = categoryCode === 0 ? {} : { category_code: categoryCode };
  return (
    <section className="block bg-white border border-white border-t-none shadow mb-3 p-3">
      <article className="w-full">
        <div className="block ml-auto mr-auto mb-3">
          <h1 className="text-2xl font-bold">{pageTitle}</h1>
          <p className="text-xs flex">
            {pager.formatCurrentCount}件/{props.pager.formatTotalCount}件
          </p>
        </div>
        <Tab currentIndex={Config.TOPIC_SORT_MAP.has(sort) ? sort : 1} basePathname={basePathname} baseAsPath={baseAsPath} baseQuery={baseQuery} />
        <List
          showBorder={true}
          showLastUpdatedAt={sort !== 2 && sort !== 3}
          topics={topics}
          categories={categories}
          emptyMessage="投稿されたトピックはありません"
        />
      </article>
    </section>
  );
};

export default TopicListComponent;
